import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import Iconify from '../../../components/iconify';
import api from '../../../api';
import { loadingStartAction } from 'src/redux/actions/loadingActions';

// ----------------------------------------------------------------------

export default function AdminPaymentDetails({ data, getAllSettings }) {
  const dispatch = useDispatch();
  // States for input fields
  const [upiName, setUPIName] = useState(data?.paymentDetails?.upi_name || '');
  const [upiID, setUPIId] = useState(data?.paymentDetails?.upi_id || '');

  const handleSave = async () => {
    let reqBody = {
      paymentDetails: {
        bankName: data?.paymentDetails?.bankName,
        accountNumber: data?.paymentDetails?.accountNumber,
        ifscCode: data?.paymentDetails?.ifscCode,
        upi_name: upiName,
        upi_id: upiID,
      },
    };

    dispatch(loadingStartAction());
    await api.put('/settings', reqBody);
    getAllSettings();
  };
  return (
    <>
      <Stack spacing={3}>
        <TextField name="upi_name" label="UPI Name" value={upiName} onChange={(e) => setUPIName(e.target.value)} />
        <TextField name="upi_id" label="UPI ID" value={upiID} onChange={(e) => setUPIId(e.target.value)} />
      </Stack>

      <br />
      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleSave}>
        SAVE
      </LoadingButton>
    </>
  );
}
